<script setup>
import { computed } from "vue";
import { ICON_PATHS } from "@/components/icons/paths";

const props = defineProps({ name: { type: String, required: true } });
// Hardcoded SVG <path> literals from paths.ts (no user input) — safe to v-html.
const path = computed(() => ICON_PATHS[props.name] ?? "");
</script>

<template>
  <svg
    class="w-5 h-5 flex-shrink-0"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
    v-html="path"
  />
</template>
